<template>
  <div class="mtnpay-warp">
    <div class="mtnpay-title">{{ i18n.id_card }}</div>
    <div class="mtnpay-row">
      <input type="number" v-model="idCard" :placeholder="i18n.id_card" @input="handleInput" />
    </div>
    <div class="mtnpay-btn">
      <div class="btn" @click="onSubmit">{{ i18n.submit }}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    i18n() {
      return this.$t("confirm")
    }
  },
  data() {
    return {
      idCard: ''
    }
  },
  methods: {
    handleInput(e) {
      // 只保留数字
      let temp = e.target.value.replace(/[^\d]/g, '')
      this.idCard = temp
    },
    onSubmit() {
      if (!this.idCard) {
        this.$toast(this.id_card_tips)
        return
      }
      this.$emit('change', this.idCard)
    }
  }
}
</script>

<style lang="less" scoped>
.mtnpay-warp {
  background: #FFFFFF;
  border-radius: 68px 68px 0px 0px;
  .mtnpay-title {
    font-size: 35px;
    font-weight: bold;
    padding: 0 0 48px;
  }
  .mtnpay-row {
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 4px solid #D5D5D5;
    border-radius: 10px;
    padding: 0 20px;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }

    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: #000 transparent transparent;
    }

    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );
      margin-right: 20px;

      img {
        width: 180px;
        height: 60px;
      }
    }
  }
  .mtnpay-btn {
    margin-top: 60px;
  }
}
</style>
